// extracted by mini-css-extract-plugin
export default {"meal":"MealItem_meal__Hk-M2","description":"MealItem_description__GwCVI","price":"MealItem_price__--mbx"};